import React from 'react';

export default class Table extends React.Component {
  constructor(props) {
    super(props);
  }

  buildHeader(header) {
    if (header) {
      return (
        <thead>
          <tr>{header.map(item => <th>{item}</th>)}</tr>
        </thead>
      );
    } else {
      return '';
    }
  }

  buildBody(rows) {
    if (rows) {
      return (
        <tbody>
          {rows.map(col => (
            <tr>{col.map(cell => {
                let customArgs = null;
                let value = '';
                if (typeof cell === 'object') {
                  customArgs = { className: cell.customStyle };
                  value = cell.value;
                } else {
                  value = cell;
                }
                return <td {...customArgs}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      );
    } else {
      return '';
    }
  }

  render() {
    return (
      <table>
        {this.buildHeader(this.props.header)}
        {this.buildBody(this.props.data, this.props.styles)}
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/table/Table.js